type Props = {
    searchQuery: string;
    onSearchChange: (v: string) => void;
    selectedScope: string;
    onScopeChange: (v: string) => void;
    scopes: string[];
    onNewUser: () => void;
};

export function UserToolbar({ searchQuery, onSearchChange, selectedScope, onScopeChange, scopes, onNewUser }: Props) {
    return (
        <div className="toolbar">
            <input
                className="control"
                placeholder="Search by email"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
            />
            <select
                className="control"
                value={selectedScope}
                onChange={(e) => onScopeChange(e.target.value)}
            >
                <option value="all">Scope (all)</option>
                {scopes.map(s => (
                    <option key={s} value={s}>{s}</option>
                ))}
            </select>
            <button className="btn-primary" onClick={onNewUser}>+ New user</button>
        </div>
    );
}
